import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { createBrowserHistory } from 'history'
import moment from 'moment'
import Button from '../../components/atom/button/Button'
import Loading from '../../components/atom/loading/Loading'

// globals
import * as constants from '../../globals/constants'
import * as TYPE from '../../globals/type'

// utils
import { useAxios } from '../../utils/useAxios'

// styles
import colors from '../../styles/colors'

// images
import NewButton from '../../assets/image/button/ico-new.svg'

const NoticeDetail = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  const navigate = useNavigate()
  const location = useLocation()
  const history = createBrowserHistory()

  const { id } = useParams()
  const { fetchData, loading, data } = useAxios()
  const [noticeInfo, setNoticeInfo] = useState([])
  const [listPageNumber, setListPageNumber] = useState(
    location?.state?.pageNum ?? 1,
  )
  const [isPrevDashboard, setIsPrevDashboard] = useState(
    location?.state?.isDashboard ?? false,
  )

  useEffect(() => {
    const params = {
      noticeId: id,
      modified: location?.state?.modified,
    }

    fetchData(constants.API.NOTICE_DETAIL, 'POST', null, params)

    // 뒤로가기 처리
    const onPreventBack = () => {
      history.push(null, '', location.href)

      // 이전 페이지: 대시보드
      if (isPrevDashboard) {
        navigate('/')
      }
      // 이전 페이지: 공지사항 목록
      else {
        onBackPage()
      }
    }

    history.push(null, '', location.href)
    window.addEventListener('popstate', onPreventBack)

    return () => window.removeEventListener('popstate', onPreventBack)
  }, [])

  useEffect(() => {
    if (data?.responseData?.ntcContent) {
      setNoticeInfo(data.responseData)
      // getDashboard()
    }

    //old code
    let result = data?.responseData ?? null

    // 공지사항 상세 조회
    if (data?.responseData && !result?.topNoticeResult) {
      // setNoticeInfo(data.resultData.noticeInfo)
      getDashboard()
    }

    // console.log('$$ notice', data)

    // 공지사항 사이드바 아이콘 처리
    if (
      data?.responseCode === TYPE.API_RESPONSE.SUCCESS &&
      result?.topNoticeResult
    ) {
      // 로컬 스토리지 추가(새로운 공지사항 체크)
      localStorage.setItem('isNewNotice', result?.isNewNotice)
      window.dispatchEvent(new Event('storage'))
    }
  }, [data])

  // 공지사항 아이콘 체크
  const getDashboard = () => {
    const params = {
      isNoticeDetail: true,
    }

    fetchData(constants.API.DASHBOARD, 'GET', null, params)
  }

  const htmlDecode = (html) => {
    let e = document.createElement('div')
    e.innerHTML = html

    return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue
  }

  const onBackPage = () => {
    navigate('/happyOrderNoticeList', {
      state: {
        prevNum: listPageNumber,
      },
    })
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <NoticeDetailWrap>
            <h1 className="ntcHeader">해피오더 공지</h1>
            <NoticeDetailBox>
              {!noticeInfo.ntcContent ? (
                ''
              ) : (
                <NtcTitleBox>
                  <div className="titleBox">
                    {/* {noticeInfo.readYn !== 'Y' && (
                      <img src={NewButton} alt="" />
                    )} */}
                    <h2 className="ntcTitle">{noticeInfo.ntcTitle}</h2>
                  </div>

                  <p className="ntcManager">
                    해피오더 관리자
                    <span className="ntcDate">
                      {noticeInfo.modified
                        ? moment(noticeInfo.modified, 'YYYYMMDDHHmmss').format(
                            'YYYY-MM-DD',
                          )
                        : ''}
                    </span>
                  </p>
                </NtcTitleBox>
              )}

              <NtcContent>
                {/* <p className="ntcContent" dangerouslySetInnerHTML={{ __html: noticeInfo.ntcContent }}>{noticeInfo.ntcContent}</p> */}
                <div
                  dangerouslySetInnerHTML={{
                    __html: htmlDecode(
                      !noticeInfo.ntcContent ? '' : noticeInfo.ntcContent,
                    ),
                  }}
                />
              </NtcContent>
            </NoticeDetailBox>
            <Button
              className="mt-3"
              width={181 + 'px'}
              onClick={onBackPage}
              // onClick={() => navigate('/happyOrderNoticeList')}
            >
              목록으로
            </Button>
          </NoticeDetailWrap>
          <NoticeDetailMoWrapper>
            {!noticeInfo.ntcContent ? (
              ''
            ) : (
              <HeaderDetail>
                <div>해피오더 관리자</div>
                <div>
                  {noticeInfo.modified
                    ? moment(noticeInfo.modified, 'YYYYMMDDHHmmss').format(
                        'YYYY-MM-DD',
                      )
                    : ''}
                </div>
                <div>
                  {/* {noticeInfo.readYn !== 'Y' && <img src={NewButton} alt="" />} */}
                  <span>{noticeInfo.ntcTitle}</span>
                </div>
              </HeaderDetail>
            )}

            <BodyDetail>
              <div
                dangerouslySetInnerHTML={{
                  __html: htmlDecode(
                    !noticeInfo.ntcContent ? '' : noticeInfo.ntcContent,
                  ),
                }}
              />
            </BodyDetail>
            <FooterDetail onClick={onBackPage}>목록으로 가기</FooterDetail>
          </NoticeDetailMoWrapper>
        </>
      )}
    </>
  )
}

export default NoticeDetail

const NoticeDetailWrap = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 15px;
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.1);
  background-color: #fff;
  max-width: 768px;
  width: 100%;
  /* height: 809px; */
  margin: 0 auto;
  padding: 30px;
  .ntcHeader {
    font-size: 16px;
    font-weight: bold;
    color: #000;
    margin-bottom: 40px;
    /* display: none;
    @media ${(props) => props.theme.desktop} {
      display: block;
    } */
  }

  @media ${(props) => props.theme.mobile} {
    display: none;
  }
`
const NoticeDetailBox = styled.div`
  width: 100%;
  /* border-top: 1px solid #e5e5e5; */
  border-bottom: 1px solid #e5e5e5;
`
const NtcTitleBox = styled.div`
  padding: 15px 0px;
  border-bottom: 1px solid #e5e5e5;
  .titleBox {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
    gap: 5px;
  }
  .ntcTitle {
    font-size: 16px;
    color: #000;
    /* margin-bottom: 10px; */
  }
  .ntcManager {
    font-size: 14px;
    color: #000;
  }
  .ntcDate {
    font-size: 14px;
    color: #8a8a8a;
    margin-left: 15px;
  }
`

const NtcContent = styled.div`
  width: 100%;
  min-height: 200px;
  padding: 20px 0 20px;
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
  overflow: auto;
  line-height: 1.5;

  .ntcContent {
    font-size: 16px;
    color: #000;
    line-height: 1.5;
  }
  img {
    width: 708px;
    height: 368px;
    object-fit: contain;
    border-radius: 8px;
  }
`

const NoticeDetailMoWrapper = styled.div`
  display: none;

  @media ${(props) => props.theme.mobile} {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
  }
`

const HeaderDetail = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${colors.G5};

  div:nth-child(1) {
    font-size: 14px;
    margin-bottom: 10px;
    color: ${colors.BK};
  }

  div:nth-child(2) {
    font-size: 12px;
    margin-bottom: 20px;
    color: ${colors.G4};
  }

  div:nth-child(3) {
    display: flex;
    align-items: center;
    margin-bottom: 14.5px;

    font-size: 14px;
    font-weight: 700;
    color: ${colors.BK};

    img {
      margin-right: 5px;
      width: 40px;
      height: 20px;
    }
  }
`

const BodyDetail = styled.div`
  display: flex;
  padding: 20px 0 28px;
  font-size: 14px;
  color: ${colors.BK};
  line-height: 1.5;
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  overflow: auto;
  line-height: 1.5;
`

const FooterDetail = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50px;
  font-size: 14px;
  border-radius: 8px;
  color: ${colors.BK};
  border: 1px solid ${colors.G3};
  cursor: pointer;
`
